import Highcharts from 'highcharts'
import highchartsMore from "highcharts/highcharts-more.js"
import solidGauge from "highcharts/modules/solid-gauge.js";
// import itemSeries from "highcharts/modules/item-series.js";
import HighchartsReact from 'highcharts-react-official'
import React, { useReducer, useEffect } from "react";
import { formatNumber, formatCurrency, formatPercent, formatItems, isNumeric } from '../helpers/utils';
import WaffleChart from './WaffleChart';
import ChartTable from './ChartTable';
import _ from 'lodash';
import chartColorService from '../helpers/ChartColorService';

highchartsMore(Highcharts);
solidGauge(Highcharts);
// itemSeries(Highcharts);

const GRAY_COLORS = ["#eee", "#ddd", "#ccc", "#bbb", "#aaa", "#999", "#888", "#777"];
const DEFAULT_COLORS = ["#4C7289", "#7D1327", "#C1CB80", "#8A8D32", "#FDD773", "#DB8925", "#7BAFD4", "#6C345F", "#62B1BD", "#6F625A", "#EEECE1"];

const GAUGE_COLOR = "#7bafd4";
const PEER_COLOR = "#7bafd4";
const TARGET_COLOR = "#C1CB80";
const YOU_COLOR = "#666";
const FONT_FAMILY = 'IBM Plex Sans';
const FONT_SIZE = '14px';
const CHART_HEIGHT = 320;
const SHOW_HIGHCHARTS_ANIMATION = false;

const defaultPieChartOptions = {
	chart: {
		style: {
			fontFamily: FONT_FAMILY,
			fontSize: FONT_SIZE
		},
		backgroundColor: null,
		height: CHART_HEIGHT,
		type: "pie",
	},
	tooltip: {
		// pointFormat: '{point.y} responses ({point.percentage:.0f}%)'
		// format: '<svg width="10" height="10" style="color:{point.color}">●</svg> {point.y} responses ({point.percentage:.0f}%)',
		format: '<svg width="10" height="10" style="color:{point.color}">●</svg> <strong>{point.name}</strong><br/><svg width="10" height="10" style="color:white">●</svg> {point.percentage:.0f}%',
		style: {
			fontSize: '1em'
		},
		shadow: {
			color: 'rgba(0, 0, 0, 0.33)',
		}
	},
	title: {
		text: undefined
	},
	credits: {
		enabled: false
	},
	legend: {
		enabled: false
	},
	plotOptions: {
		pie: {
			minSize: 200,
			dataLabels: {
				connectorShape: 'fixedOffset',
				softConnector: true,
				allowOverlap: true,
				connectorPadding: 0,
			}
		},
		series: {
			animation: SHOW_HIGHCHARTS_ANIMATION,
			innerSize: '70%',
			borderWidth: 2,
			borderColor: 'white',
			dataLabels: {
				style: {
					color: "rgb(51, 51, 51)",
					fontWeight: "300",
					fontSize: '1em',
					textOutline: false,
					textOverflow: 'clip',
				},
			}
		}
	},
	series: []
}
const defaultNestedPieChartOptions = {
	chart: {
		style: {
			fontFamily: FONT_FAMILY,
			fontSize: FONT_SIZE
		},
		backgroundColor: null,
		height: CHART_HEIGHT,
		type: "pie"
	},
	tooltip: {
		// pointFormat: '{point.y} responses ({point.percentage:.0f}%)'
		format: '<svg width="10" height="10" style="color:{point.color}">●</svg> {series.name}<br/><svg width="10" height="10" style="color:white">●</svg> {point.name}: <strong>{point.percentage:.0f}%</strong>',
		style: {
			fontSize: '1em'
		}
	},
	title: {
		text: undefined,
	},
	credits: {
		enabled: false
	},
	legend: {
		enabled: false
	},
	plotOptions: {
		pie: {
			minSize: 200,

		},
		series: {
			animation: SHOW_HIGHCHARTS_ANIMATION,
			borderWidth: 2,
			borderColor: 'white'
		}
	},
	series: [
		{
			name: 'All responses',
			data: [],
			size: '100%',
			innerSize: '70%',
			dataLabels: {
				style: {
					color: "rgb(51, 51, 51)",
					fontWeight: "300",
					fontSize: '1em',
					textOutline: false
				}
			}
		},
		{
			name: 'Peer responses',
			data: [],
			size: '75%',
			innerSize: '70%',
			dataLabels: {
				enabled: false
			}
		}

	]
}
const defaultPieChartWithLegendOptions = {
	chart: {
		style: {
			fontFamily: FONT_FAMILY,
			fontSize: FONT_SIZE
		},
		backgroundColor: null,
		height: CHART_HEIGHT,
		type: "pie",
	},
	tooltip: {
		// pointFormat: '{point.y} responses ({point.percentage:.0f}%)'
		// format: '<svg width="10" height="10" style="color:{point.color}">●</svg> {point.y} responses ({point.percentage:.0f}%)',
		format: '<svg width="10" height="10" style="color:{point.color}">●</svg> <strong>{point.name}</strong><br/><svg width="10" height="10" style="color:white">●</svg> {point.percentage:.0f}%',
		style: {
			fontSize: '1em'
		},
		shadow: {
			color: 'rgba(0, 0, 0, 0.33)',
		}
	},
	title: {
		text: undefined
		// useHTML: true,
		// text: "",
		// verticalAlign: 'middle',
		// floating: true,
		// style: {
		// 	color: "rgb(51, 51, 51)",
		// 	fontWeight: "600",
		// 	fontSize: "36px",
		// 	lineHeight: '0.5',
		// 	textAlign: "center",
		// 	textOutline: false
		// }
	},
	credits: {
		enabled: false
	},
	legend: {
		layout: 'horizontal',
		align: 'center',
		verticalAlign: 'bottom',
		// align: 'right',
		// verticalAlign: 'middle',
		// layout: 'vertical',		
		floating: false,
		itemStyle: {
			textOverflow: null,
			fontSize: '1em'
		}
	},
	plotOptions: {
		pie: {
			// center: ['50%', '50%'],
			dataLabels: {
				enabled: false
			},
			showInLegend: true,
			minSize: 200,

		},
		series: {
			animation: SHOW_HIGHCHARTS_ANIMATION,
			innerSize: '70%',
			borderWidth: 2,
			borderColor: 'white'
		}
	},
	series: []
}
const defaultStackedBarChartOptions = {
	chart: {
		style: {
			fontFamily: FONT_FAMILY,
			fontSize: FONT_SIZE
		},
		backgroundColor: null,
		height: CHART_HEIGHT,
		type: "bar"
	},
	tooltip: {
		format: '<svg width="10" height="10" style="color:{series.color}">●</svg> <strong>{series.name}</strong><br/><svg width="10" height="10" style="color:white">●</svg> {point.percentage:.0f}%',
		style: {
			fontSize: '1em'
		},
		shadow: {
			color: 'rgba(0, 0, 0, 0.33)',
		}
	},
	title: {
		text: undefined
	},
	credits: {
		enabled: false
	},
	legend: {
		enabled: true,
		reversed: true,
		itemStyle: {
			fontSize: '1em'
		}
	},
	xAxis: {
		categories: [],
		lineWidth: 0,
		labels: {
			style: {
				fontSize: '1em'
			}
		}
	},
	yAxis: {
		visible: false
	},
	plotOptions: {
		series: {
			animation: SHOW_HIGHCHARTS_ANIMATION,
			borderRadius: 0,
			// borderWidth: 2,
			// borderColor: 'white',
			borderColor: null,
			stacking: 'normal',
			dataLabels: {
				enabled: false,
			},
			groupPadding: 0,
			pointPadding: 0.1
		}
	},
	series: []
}
const defaultStackedColumnChartOptions = {
	chart: {
		style: {
			fontFamily: FONT_FAMILY,
			fontSize: FONT_SIZE
		},
		backgroundColor: null,
		height: CHART_HEIGHT,
		type: "column"
	},
	tooltip: {
		format: '<svg width="10" height="10" style="color:{series.color}">●</svg> <strong>{series.name}</strong><br/><svg width="10" height="10" style="color:white">●</svg> {point.percentage:.0f}%',
		style: {
			fontSize: '1em'
		},
		shadow: {
			color: 'rgba(0, 0, 0, 0.33)',
		}
	},
	title: {
		text: undefined
	},
	credits: {
		enabled: false
	},
	legend: {
		enabled: true,
		reversed: true,
		itemStyle: {
			fontSize: '1em'
		}
	},
	xAxis: {
		categories: [],
		lineWidth: 0,
		labels: {
			style: {
				fontSize: '1em'
			}
		}
	},
	yAxis: {
		visible: false
	},
	plotOptions: {
		column: {
			// borderRadius: '100%',
			// borderWidth: 2,
			// borderColor: 'white',
			stacking: 'percent',
			borderColor: null,
			dataLabels: {
				enabled: false,
			},
			groupPadding: 0,
			pointPadding: 0.1,
			maxPointWidth: 120
		},
		series: {
			animation: SHOW_HIGHCHARTS_ANIMATION
		}
	},
	series: []
}
const defaultBarChartOptions = {
	chart: {
		style: {
			fontFamily: FONT_FAMILY,
			fontSize: FONT_SIZE
		},
		backgroundColor: null,
		height: CHART_HEIGHT,
		type: "bar"
	},
	tooltip: {
		// format: '{point.y} responses',
		enabled: false
	},
	title: {
		text: undefined
	},
	credits: {
		enabled: false
	},
	legend: {
		enabled: false
	},
	xAxis: {
		categories: [],
		lineWidth: 0,
		labels: {
			style: {
				fontSize: '1em'
			}
		}
	},
	yAxis: {
		visible: false
	},
	plotOptions: {
		series: {
			animation: SHOW_HIGHCHARTS_ANIMATION,
			dataLabels: [{
				formatter: function () {
					const percentage = this.y * 100;
					const barHeight = this.point.shapeArgs?.height || 0;
					return barHeight >= 100 ? `${formatNumber(percentage)}%` : null;
				},
				enabled: true,
				inside: true,
				align: 'right',
				x: -2,
				style: {
					color: 'white',
					fontWeight: "300",
					fontSize: '1em',
					textOutline: false
				}
			}, {
				formatter: function () {
					const percentage = this.y * 100;
					const barHeight = this.point.shapeArgs?.height || 0;
					return barHeight < 100 ? `${formatNumber(percentage)}%` : null;
				},
				enabled: true,
				inside: false,
				align: 'left',
				x: 2,
				style: {
					color: '#444',
					fontWeight: "300",
					fontSize: '1em',
					textOutline: false
				}
			}],
			groupPadding: 0,
			pointPadding: 0.1
		}
	},
	series: []
}
const defaultGaugeChartOptions = {
	chart: {
		style: {
			fontFamily: FONT_FAMILY,
			fontSize: FONT_SIZE
		},
		backgroundColor: null,
		height: CHART_HEIGHT,
		type: 'gauge'
	},
	title: {
		text: undefined
	},
	credits: {
		enabled: false
	},
	legend: {
		layout: 'horizontal',
		align: 'center',
		verticalAlign: 'bottom',
		floating: false,
		itemStyle: {
			textOverflow: null,
			fontSize: '1em'
		}
	},
	pane: {
		startAngle: -90,
		endAngle: 90,
		center: ['50%', '82%'],
		size: '135%',
		background: {
			backgroundColor: "#eee",
			shape: "arc",
			outerRadius: "100%",
			innerRadius: "90%",
			borderWidth: 0
		}
	},
	plotOptions: {
		series: {
			animation: SHOW_HIGHCHARTS_ANIMATION,
			states: {
				hover: {
					enabled: false
				},
				inactive: {
					opacity: 1,
				}
			}
		}
	},
	yAxis: {
		min: 0,
		max: 200,
		labels: {
			distance: 10,
			rotation: 'auto',
			style: {
				fontSize: '1em'
			}
		},
		tickLength: 20,
		tickWidth: 2,
		tickColor: "white",
		// minorTickInterval: null,
		minorTickLength: 10,
		minorTickWidth: 2,
		minorTickColor: "rgba(255, 255, 255, 0.5)",
		lineWidth: 0,
		endOnTick: true,
		startOnTick: true,
		plotBands: []
	},
	tooltip: {
		enabled: false
	},
	series: [
		{
			data: [],
			dataLabels: {
				enabled: false
			},
			crisp: false,
			color: TARGET_COLOR,
			name: "Target",
			pivot: {
				radius: 16,
				backgroundColor: TARGET_COLOR,
			},
			dial: {
				radius: '88%',
				backgroundColor: TARGET_COLOR,
				baseWidth: 20,
				baseLength: '0%',
				rearLength: '0%'
			},
			// showInLegend: true,
			showInLegend: false, // Temporarily suppressing this indicator
			visible: false // Temporarily suppressing this indicator
		},
		{
			data: [],
			dataLabels: {
				enabled: false
			},
			crisp: false,
			color: PEER_COLOR,
			name: "Peers",
			pivot: {
				radius: 16,
				backgroundColor: GAUGE_COLOR,
			},
			dial: {
				radius: '88%',
				backgroundColor: GAUGE_COLOR,
				baseWidth: 20,
				baseLength: '0%',
				rearLength: '0%'
			},
			showInLegend: true
		},
		{
			data: [],
			dataLabels: {
				// format: '{y}',
				borderWidth: 0,
				style: {
					color: "rgb(51, 51, 51)",
					fontWeight: "600",
					textOutline: false,
					fontSize: '16px',
				}
			},
			crisp: false,
			color: YOU_COLOR,
			name: "You",
			pivot: {
				radius: 16,
				backgroundColor: YOU_COLOR
			},
			dial: {
				radius: '70%',
				backgroundColor: YOU_COLOR,
				baseWidth: 20,
				baseLength: '0%',
				rearLength: '0%'
			},
			showInLegend: true
		}
	]
}
const defaultColumnChartOptions = {
	chart: {
		style: {
			fontFamily: FONT_FAMILY,
			fontSize: FONT_SIZE
		},
		backgroundColor: null,
		height: CHART_HEIGHT,
		type: "column"
	},
	tooltip: {
		enabled: false
	},
	title: {
		text: undefined
	},
	credits: {
		enabled: false
	},
	legend: {
		enabled: false
	},
	xAxis: {
		categories: [],
		lineWidth: 0,
		labels: {
			style: {
				fontSize: '1em'
			}
		}
	},
	yAxis: {
		visible: false
	},
	plotOptions: {
		series: {
			animation: SHOW_HIGHCHARTS_ANIMATION,
			dataLabels: [{
				// Labels inside bars (for tall bars)
				formatter: function () {
					const barHeight = this.point.shapeArgs?.height || 0;
					return barHeight >= 30 ? `${Math.round(this.y * 100)}%` : null;
				},
				enabled: true,
				align: 'center',
				verticalAlign: 'middle',
				y: 15, // Center in the bar
				style: {
					color: 'white',
					fontWeight: "300",
					fontSize: '1em',
					textOutline: false
				}
			}, {
				// Labels above bars (for short bars)
				formatter: function () {
					const barHeight = this.point.shapeArgs?.height || 0;
					return barHeight < 30 ? `${Math.round(this.y * 100)}%` : null;
				},
				enabled: true,
				align: 'center',
				verticalAlign: 'bottom',
				y: 0, // Position above the bar
				style: {
					color: '#444',
					fontWeight: "300",
					fontSize: '1em',
					textOutline: false
				}
			}],
			groupPadding: 0.05,
			pointPadding: 0,
			maxPointWidth: 120
		}
	},
	series: []
}
const defaultGroupedColumnChartOptions = {
	chart: {
		style: {
			fontFamily: FONT_FAMILY,
			fontSize: FONT_SIZE
		},
		backgroundColor: null,
		height: CHART_HEIGHT,
		type: "column"
	},
	tooltip: {
		format: '<svg width="10" height="10" style="color:{series.color}">●</svg> <strong>{series.name}</strong><br/><svg width="10" height="10" style="color:white">●</svg> {point.y:.0f}%',
		style: {
			fontSize: '1em'
		},
		shadow: {
			color: 'rgba(0, 0, 0, 0.33)',
		}
	},
	title: {
		text: undefined
	},
	credits: {
		enabled: false
	},
	legend: {
		enabled: true,
		itemStyle: {
			fontSize: '1em'
		}
	},
	xAxis: {
		categories: [],
		lineWidth: 0,
		labels: {
			style: {
				fontSize: '1em'
			},
			y: 20
		}
	},
	yAxis: {
		title: false,
		labels: {
			formatter: function () {
				return formatPercent(this.value);
			}
		}
	},
	plotOptions: {
		series: {
			animation: SHOW_HIGHCHARTS_ANIMATION,
			// dataLabels: {
			// 	formatter: function () {
			// 		return formatPercent(this.y);
			// 	},
			// 	enabled: true,
			// 	align: 'center',
			// 	y: 30,
			// 	style: {
			// 		color: 'white',
			// 		fontWeight: "300",
			// 		fontSize: '1em',
			// 		textOutline: false
			// 	}
			// },
			groupPadding: 0.05,
			pointPadding: 0,
			maxPointWidth: 120
		}
	},
	series: []
}
const reducer = (state, action) => {
	let
		total,
		results,
		categories,
		categoriesIndexes,
		series,
		seriesNames,
		seriesIndexes,
		data,
		respondents;

	// const answered = !(action.payload.answered === false);
	const dataWithheld = action.payload.dataWithheld;
	const surveyQuestionId = action.payload.surveyQuestionId;
	// console.log(`Highcharts reducer action.type: ${action.type} surveyQuestionId: ${surveyQuestionId}`);
	switch (action.type) {
		case ACTION.NEW_PIE_CHART_DATA:
			// console.log(action.payload);
			const newPieChartOptions = _.cloneDeep(action.payload.showLegend ? defaultPieChartWithLegendOptions : defaultPieChartOptions);

			// if (dataWithheld) {
			// 	newPieChartOptions.colors = [...GRAY_COLORS];
			// } else {
			// 	newPieChartOptions.colors = [...DEFAULT_COLORS];
			// }

			if (action.payload.chartHeight !== undefined) {
				newPieChartOptions.chart.height = action.payload.chartHeight;
			}

			total = 0;
			data = [];
			try {
				for (let response of action.payload.responses) {
					let value = action.payload.type === "constant sum" ? response.percent : response.responses;
					data.push({
						name: response.text,
						y: value,
						color: chartColorService.getColorForLabel(action.payload.surveyQuestionId, response.text, dataWithheld ? "Inactive" : "Active")
					});
					total += response.responses;
				}
				newPieChartOptions.series[0] = {
					data
				}

				if (action.payload.type === "constant sum") {
					newPieChartOptions.tooltip.format = '<svg width="10" height="10" style="color:{point.color}">●</svg> <strong>{point.name}</strong><br/><svg width="10" height="10" style="color:white">●</svg> {point.percentage:.1f}%'
				}

			} catch (e) {
				console.log("Error handling pie chart data", e);
				console.log(action.payload);
			}
			return { ...state, chartOptions: newPieChartOptions, surveyQuestionId: surveyQuestionId, dataLoaded: (data.length > 0) };
		case ACTION.NEW_NESTED_PIE_CHART_DATA:
			// console.log(action.payload);
			const newNestedPieChartOptions = _.cloneDeep(defaultNestedPieChartOptions);

			// if (dataWithheld) {
			// 	newNestedPieChartOptions.colors = [...GRAY_COLORS];
			// } else {
			// 	newNestedPieChartOptions.colors = [...DEFAULT_COLORS];
			// }
			if (action.payload.chartHeight !== undefined) {
				newNestedPieChartOptions.chart.height = action.payload.chartHeight;
			}


			data = [];
			try {
				for (let response of action.payload.responses.overall) {
					let value = response.responses;
					data.push({
						name: response.text,
						y: value,
						color: chartColorService.getColorForLabel(action.payload.surveyQuestionId, response.text, dataWithheld ? "Inactive" : "Active") 
					});
				}
				newNestedPieChartOptions.series[0].data = data;
				let filtered = [];
				for (let response of action.payload.responses.filtered) {
					let value = response.responses;
					filtered.push({
						name: response.text,
						y: value,
						color: chartColorService.getColorForLabel(action.payload.surveyQuestionId, response.text, dataWithheld ? "Inactive" : "Active") 
					});
				}
				newNestedPieChartOptions.series[1].data = filtered;
			} catch (e) {
				console.log("Error handling pie chart data", e);
				console.log(action.payload);
			}
			return { ...state, chartOptions: newNestedPieChartOptions, surveyQuestionId: surveyQuestionId, dataLoaded: (data.length > 0) };
		case ACTION.NEW_WAFFLE_CHART_DATA:
			// console.log(action.payload);
			const newWaffleChartOptions = {};

			total = 0;
			let cellsRemaining = 100;
			data = [];
			try {
				for (let response of action.payload.responses) {
					total += response.responses;
					data.push({
						name: response.text,
						value: response.responses
					});
				}
				data.sort((a, b) => {
					return b.value - a.value;
				});

				for (let i = 0, l = data.length; i < l; i++) {
					let cells = total === 0 ? 0 : Math.round(cellsRemaining * data[i].value / total);
					total -= data[i].value;
					cellsRemaining -= cells;
					data[i].value = cells;
				}
				newWaffleChartOptions.data = [...data];
			} catch (e) {
				console.log("Error handling waffle chart data", e);
				console.log(action.payload);
			}
			return { ...state, chartOptions: newWaffleChartOptions, surveyQuestionId: surveyQuestionId, dataLoaded: (data.length > 0) };
		case ACTION.NEW_CHART_TABLE_DATA:
			// console.log(action.payload);

			const chartTableData = [];

			try {

				if (action.payload.responses !== undefined) {
					for (let response of action.payload.responses) {
						chartTableData.push({
							text: response.text,
							all: response.percent,
							displayOrder: response.displayOrder,
							constantSumStatementId: response.constantSumStatementId
						});
					}

					// map peer responses

					for (let response of action.payload.peer_responses) {
						let found = false;
						let row;
						for (row of chartTableData) {
							if (row.constantSumStatementId === response.constantSumStatementId) {
								found = true;
								break;
							}
						}
						if (found) {
							row.peers = response.percent;
						} else {
							chartTableData.push({
								text: response.text,
								peers: response.percent,
								displayOrder: response.displayOrder,
								constantSumStatementId: response.constantSumStatementId
							});
						}
					}

					// map advisor responses

					if (action.payload.advisor_responses) {
						for (let response of action.payload.advisor_responses) {
							let row;
							for (row of chartTableData) {
								if (row.constantSumStatementId === response.constantSumStatementId) {
									row.advisor = response.response;
									break;
								}
							}
						}
					}

					chartTableData.sort((a, b) => {
						return a.displayOrder - b.displayOrder;
					})

				}
			} catch (e) {
				console.log("Error handling chart table data", e);
				console.log(action.payload);

			}

			return { ...state, chartOptions: chartTableData, surveyQuestionId: surveyQuestionId, dataLoaded: (chartTableData.length > 0) };
		case ACTION.NEW_STACKED_BAR_CHART_DATA:
			const newStackedBarChartOptions = _.cloneDeep(defaultStackedBarChartOptions);

			// if (dataWithheld) {
			// 	newStackedBarChartOptions.colors = [...GRAY_COLORS];
			// } else {
			// 	newStackedBarChartOptions.colors = [...DEFAULT_COLORS];
			// }
			if (action.payload.chartHeight !== undefined) {
				newStackedBarChartOptions.chart.height = action.payload.chartHeight;
			}


			categories = [];
			categoriesIndexes = {};
			series = [];
			seriesIndexes = {};

			respondents = action.payload.respondents || 0;

			try {

				for (let statement of action.payload.statements) {
					let index = categories.push(statement.text);
					categoriesIndexes[statement.matrixStatementId] = index - 1;
				}
				for (let answerChoice of action.payload.answerChoices) {
					let index = series.push({
						name: answerChoice.text,
						color: chartColorService.getColorForLabel(action.payload.surveyQuestionId, answerChoice.text, dataWithheld ? "Inactive" : "Active"),
						data: []
					});
					seriesIndexes[answerChoice.matrixAnswerChoiceId] = index - 1;
				}
				for (let i = 0; i < series.length; i++) {
					for (let j = 0; j < categories.length; j++) {
						series[i].data[j] = 0;
					}
				}
				for (let response of action.payload.responses) {
					try {
						let categoriesIndex = categoriesIndexes[response.matrixStatementId];
						let seriesIndex = seriesIndexes[response.matrixAnswerChoiceId];
						if (isNumeric(response.responses)) {
							series[seriesIndex].data[categoriesIndex] = response.responses;
						}
					} catch (e) {
						console.log("Error: count not insert value into series array", response, e);
					}
				}
				// Highcharts displays stacked bar charts with series 1 on the far left ("top"), and series n on the right ("bottom")
				// So, we need to reverse this order
				series = series.reverse();

			} catch (e) {
				console.log("Error parsing stacked bar chart data", e);
				console.log(action.payload);
			}
			newStackedBarChartOptions.xAxis.categories = [...categories];
			newStackedBarChartOptions.series = [...series];

			return { ...state, chartOptions: newStackedBarChartOptions, surveyQuestionId: surveyQuestionId, dataLoaded: ((categories.length > 0) && (series.length > 0) && (action.payload.responses.length > 0)) };
		case ACTION.NEW_STACKED_COLUMN_CHART_DATA:
			const newStackedColumnChartOptions = _.cloneDeep(defaultStackedColumnChartOptions);

			// if (dataWithheld) {
			// 	newStackedColumnChartOptions.colors = [...GRAY_COLORS];
			// } else {
			// 	newStackedColumnChartOptions.colors = [...DEFAULT_COLORS];
			// }
			if (action.payload.chartHeight !== undefined) {
				newStackedColumnChartOptions.chart.height = action.payload.chartHeight;
			}

			categories = [];
			categoriesIndexes = {};
			seriesNames = [];
			series = [];
			seriesIndexes = {};

			try {

				let orderedCategories = false;
				for (let response of action.payload.responses) {
					if (response.order !== undefined) {
						orderedCategories = true;
						break;
					}
				}

				// parse categories

				if (orderedCategories) {
					let temp = [];
					let unique = {};
					for (let response of action.payload.responses) {
						if (response.order !== undefined) {
							if (unique[response.order] === undefined) {
								unique[response.order] = true;
								temp.push({
									order: response.order,
									category: response.category
								})
							}
						}
					}
					temp.sort((a, b) => { return a.order - b.order });
					for (let category of temp) {
						let index = categories.push(category.category);
						categoriesIndexes[category.category] = index - 1;
					}
				} else {
					let unique = {};
					for (let response of action.payload.responses) {
						if (unique[response.category] === undefined) {
							unique[response.category] = true;
							let index = categories.push(response.category);
							categoriesIndexes[response.category] = index - 1;
						}
					}
				}

				// parse series

				let temp = [];
				let unique = {};
				for (let response of action.payload.responses) {
					if (response.displayOrder !== undefined) {
						if (unique[response.displayOrder] === undefined) {
							unique[response.displayOrder] = true;
							temp.push({
								order: response.displayOrder,
								text: response.text
							})
						}
					}
				}
				temp.sort((a, b) => { return a.order - b.order });
				for (let name of temp) {
					let index = seriesNames.push(name.text);
					seriesIndexes[name.text] = index - 1;
				}

				for (let name of seriesNames) {
					data = {
						name: name,
						color: chartColorService.getColorForLabel(action.payload.surveyQuestionId, name, dataWithheld ? "Inactive" : "Active"),
						data: []
					}
					for (let i = 0, l = categories.length; i < l; i++) {
						data.data.push(0);
					}
					series.push(data);
				}

				for (let response of action.payload.responses) {
					let category = response.category;
					let seriesName = response.text;
					let categoryIndex = categoriesIndexes[category];
					let seriesIndex = seriesIndexes[seriesName];
					// console.log(`category: ${category} categoryIndex: ${categoryIndex} seriesName: ${seriesName} seriesIndex: ${seriesIndex}`);
					series[seriesIndex].data[categoryIndex] = response.responses;
				}

				// console.log("\n\n\n\n\n\n");
				// console.log(categories);
				// console.log(categoriesIndexes);
				// console.log(seriesNames);
				// console.log(seriesIndexes);
				// console.log(series);
				// console.log("\n\n\n\n\n\n");

				// Highcharts displays stacked bar charts with series 1 on the far left ("top"), and series n on the right ("bottom")
				// So, we need to reverse this order
				series = series.reverse();

			} catch (e) {
				console.log("Error parsing stacked bar chart data", e);
				console.log(action.payload);
			}
			newStackedColumnChartOptions.xAxis.categories = [...categories];
			newStackedColumnChartOptions.series = [...series];

			let xAxisTitle;
			switch (action.payload.chartType) {
				case "age crosstab":
					xAxisTitle = "by Advisor Age"
					break;
				case "gender crosstab":
					xAxisTitle = "by Advisor Gender"
					break;
				case "firm type crosstab":
					xAxisTitle = "by Firm Type"
					break;
				case "team crosstab":
					xAxisTitle = "by Team Type"
					break;
				case "AUM crosstab":
					xAxisTitle = "by Advisor AUM"
					break;
				case "tenure crosstab":
					xAxisTitle = "by Advisor Tenure"
					break;
				case "region crosstab":
					xAxisTitle = "by Advisor Region"
					break;
				default:
			}
			newStackedColumnChartOptions.xAxis.title = {
				text: xAxisTitle,
				style: {
					fontSize: '1.5em'
				}
			}


			return { ...state, chartOptions: newStackedColumnChartOptions, surveyQuestionId: surveyQuestionId, dataLoaded: ((categories.length > 0) && (series.length > 0) && (action.payload.responses.length > 0)) };
		case ACTION.NEW_BAR_CHART_DATA:
			// console.log(defaultBarChartOptions);
			// console.log(action.payload);
			const newBarChartOptions = _.cloneDeep(defaultBarChartOptions);

			if (dataWithheld) {
				newBarChartOptions.colors = [...GRAY_COLORS];
			} else {
				newBarChartOptions.colors = [...DEFAULT_COLORS];
			}
			// newBarChartOptions.colors = [...DEFAULT_COLORS];
			if (action.payload.chartHeight !== undefined) {
				newBarChartOptions.chart.height = action.payload.chartHeight;
			}
			respondents = action.payload.respondents;
			categories = [];
			data = [];
			try {
				for (let response of action.payload.responses) {
					data.push(respondents === 0 ? 0 : response.responses / respondents);
					categories.push(response.text);
				}
				newBarChartOptions.xAxis.categories = [...categories];
				newBarChartOptions.series[0] = {
					data
				};
				newBarChartOptions.plotOptions.series.groupPadding = action.payload.isMultipleChoice ? 0.02 : 0;
			} catch (e) {
				console.log("Error parsing bar chart data", e);
				console.log(action.payload);
			}
			return { ...state, chartOptions: newBarChartOptions, surveyQuestionId: surveyQuestionId, dataLoaded: (data.length > 0) };
		case ACTION.NEW_COLUMN_CHART_DATA:
			const newColumnChartOptions = _.cloneDeep(defaultColumnChartOptions);

			if (dataWithheld) {
				newColumnChartOptions.colors = [...GRAY_COLORS];
			} else {
				newColumnChartOptions.colors = [...DEFAULT_COLORS];
			}
			if (action.payload.chartHeight !== undefined) {
				newColumnChartOptions.chart.height = action.payload.chartHeight;
			}
			if ((action.payload.numberType === "items") && (action.payload.items !== undefined)) {
				newColumnChartOptions.plotOptions.series.dataLabels.formatter = function () {
					return formatItems(this.y, action.payload.items);
				}
			} else if (action.payload.numberType === "currency") {
				newColumnChartOptions.plotOptions.series.dataLabels.formatter = function () {
					return formatCurrency(this.y);
				}
			} else if (action.payload.numberType === "percent") {
				newColumnChartOptions.plotOptions.series.dataLabels.formatter = function () {
					return formatPercent(this.y);
				}
			}

			respondents = action.payload.respondents;
			categories = [];
			data = [];
			try {
				for (let response of action.payload.responses) {
					// data.push(response.responses);
					data.push(respondents === 0 ? 0 : response.responses / respondents);
					categories.push(response.text);
				}
				newColumnChartOptions.xAxis.categories = [...categories];
				newColumnChartOptions.series[0] = {
					data
				};
			} catch (e) {
				console.log("Error parsing column chart data", e);
				console.log(action.payload);
			}
			return { ...state, chartOptions: newColumnChartOptions, surveyQuestionId: surveyQuestionId, dataLoaded: (data.length > 0) };
		case ACTION.NEW_GROUPED_COLUMN_CHART_DATA:
			const newGroupedColumnChartOptions = _.cloneDeep(defaultGroupedColumnChartOptions);

			if (dataWithheld) {
				newGroupedColumnChartOptions.colors = [...GRAY_COLORS];
			} else {
				newGroupedColumnChartOptions.colors = [...DEFAULT_COLORS];
			}
			if (action.payload.chartHeight !== undefined) {
				newGroupedColumnChartOptions.chart.height = action.payload.chartHeight;
			}
			if ((action.payload.numberType === "items") && (action.payload.items !== undefined)) {
				newGroupedColumnChartOptions.plotOptions.series.dataLabels.formatter = function () {
					return formatItems(this.y, action.payload.items);
				}
			} else if (action.payload.numberType === "currency") {
				newGroupedColumnChartOptions.plotOptions.series.dataLabels.formatter = function () {
					return formatCurrency(this.y);
				}
			} else if (action.payload.numberType === "percent") {
				newGroupedColumnChartOptions.plotOptions.series.dataLabels.formatter = function () {
					return formatPercent(this.y);
				}
			}

			categories = [];
			data = [];
			try {
				for (let response of action.payload.responses) {
					data.push(response.percent);
					categories.push(response.text);
				}
				newGroupedColumnChartOptions.xAxis.categories = [...categories];
				newGroupedColumnChartOptions.series[0] = {
					name: "Advisors",
					data
				};
				newGroupedColumnChartOptions.series[1] = {
					name: "Peers",
					data: []
				};
				for (let response of action.payload.peer_responses) {
					newGroupedColumnChartOptions.series[1].data.push(response.percent);
				}
				newGroupedColumnChartOptions.series[2] = {
					name: "You",
					data: []
				};
				for (let response of action.payload.advisor_responses) {
					newGroupedColumnChartOptions.series[2].data.push(response.response);
				}

			} catch (e) {
				console.log("Error parsing grouped column chart data", e);
				console.log(action.payload);
			}
			return { ...state, chartOptions: newGroupedColumnChartOptions, surveyQuestionId: surveyQuestionId, dataLoaded: (data.length > 0) };
		case ACTION.NEW_CROSSTAB_CHART_DATA:
			const newCrosstabChartOptions = _.cloneDeep(defaultColumnChartOptions);

			if (dataWithheld) {
				newCrosstabChartOptions.colors = [...GRAY_COLORS];
			} else {
				newCrosstabChartOptions.colors = [...DEFAULT_COLORS];
			}
			if (action.payload.chartHeight !== undefined) {
				newCrosstabChartOptions.chart.height = action.payload.chartHeight;
			}


			if ((action.payload.numberType === "items") && (action.payload.items !== undefined)) {
				newCrosstabChartOptions.plotOptions.series.dataLabels.formatter = function () {
					return formatItems(this.y, action.payload.items);
				}
			} else if (action.payload.numberType === "currency") {
				newCrosstabChartOptions.plotOptions.series.dataLabels.formatter = function () {
					return formatCurrency(this.y);
				}
			} else if (action.payload.numberType === "percent") {
				newCrosstabChartOptions.plotOptions.series.dataLabels.formatter = function () {
					return formatPercent(this.y);
				}
			}

			categories = [];
			data = [];
			try {
				for (let result of action.payload.results) {
					data.push(result.value);
					categories.push(result.category);
				}
				newCrosstabChartOptions.xAxis.categories = [...categories];
				newCrosstabChartOptions.series[0] = {
					data
				};
				let xAxisTitle;
				switch (action.payload.chartType) {
					case "age crosstab":
						xAxisTitle = "by Advisor Age"
						break;
					case "gender crosstab":
						xAxisTitle = "by Advisor Gender"
						break;
					case "firm type crosstab":
						xAxisTitle = "by Firm Type"
						break;
					case "team crosstab":
						xAxisTitle = "by Team Type"
						break;
					case "AUM crosstab":
						xAxisTitle = "by Advisor AUM"
						break;
					case "tenure crosstab":
						xAxisTitle = "by Advisor Tenure"
						break;
					case "region crosstab":
						xAxisTitle = "by Advisor Region"
						break;
					default:
				}
				newCrosstabChartOptions.xAxis.title = {
					text: xAxisTitle,
					style: {
						fontSize: '1.5em'
					}
				}
			} catch (e) {
				console.log("Error parsing column chart data", e);
				console.log(action.payload);
			}
			return { ...state, chartOptions: newCrosstabChartOptions, surveyQuestionId: surveyQuestionId, dataLoaded: (data.length > 0) };
		case ACTION.NEW_GAUGE_CHART_DATA:
			const newGaugeChartOptions = _.cloneDeep(defaultGaugeChartOptions);

			if (dataWithheld) {

				// gray out the chart

				newGaugeChartOptions.series[0].pivot.backgroundColor = GRAY_COLORS[2];
				newGaugeChartOptions.series[0].dial.backgroundColor = GRAY_COLORS[2];
			}
			if (action.payload.chartHeight !== undefined) {
				newGaugeChartOptions.chart.height = action.payload.chartHeight;
			}

			let dataLoaded = false;
			try {
				results = action.payload.results;
				// console.log(action.payload);
				if ((results !== undefined) && (Object.keys(results).length > 0)) {
					dataLoaded = true;
					let response = action.payload.response;
					// let min = results.overall_min;
					// let max = results.overall_max;

					let peer_indicator_value = results.peer_percentile_50;
					// let target_indicator_value = results.target_percentile_50;
					let target_indicator_value;

					switch (action.payload.indicatorType) {
						case "1st percentile":
							target_indicator_value = results.peer_percentile_01;
							break;
						case "10th percentile":
							target_indicator_value = results.peer_percentile_10;
							break;
						case "25th percentile":
							target_indicator_value = results.peer_percentile_25;
							break;
						case "50th percentile":
							target_indicator_value = results.peer_percentile_50;
							break;
						case "75th percentile":
							target_indicator_value = results.peer_percentile_75;
							break;
						case "90th percentile":
							target_indicator_value = results.peer_percentile_90;
							break;
						case "95th percentile":
							target_indicator_value = results.peer_percentile_95;
							break;
						case "99th percentile":
							target_indicator_value = results.peer_percentile_99;
							break;
						default:
							target_indicator_value = results.peer_percentile_50;
					}

					let min = Math.min(response, results.overall_percentile_01);
					let max = Math.max(response, results.overall_percentile_99);

					newGaugeChartOptions.series[0].data = [target_indicator_value];
					newGaugeChartOptions.series[1].data = [peer_indicator_value];

					if (!isNumeric(response)) {
						newGaugeChartOptions.series[2].data = [min];
						newGaugeChartOptions.series[2].dataLabels.enabled = false;
						newGaugeChartOptions.series[2].dial.backgroundColor = "transparent"; // hide the dial
						newGaugeChartOptions.series[2].pivot.backgroundColor = "transparent";
					} else {
						newGaugeChartOptions.series[2].data = [response];
						newGaugeChartOptions.series[2].dataLabels.enabled = true;
					}

					newGaugeChartOptions.yAxis.min = min;
					newGaugeChartOptions.yAxis.max = max;

					// const plotBand = {
					// 	from: results.percentile_25,
					// 	to: results.percentile_75,
					// 	color: (!answered ? GRAY_COLORS[2] : GAUGE_COLOR),
					// 	thickness: "20%",
					// 	crisp: false
					// };


					// newGaugeChartOptions.yAxis.plotBands = [...plotBands];
					// newGaugeChartOptions.yAxis.plotBands = [plotBand];
					switch (action.payload.numberType) {
						case "currency":
							newGaugeChartOptions.series[2].dataLabels.formatter = function () {
								return formatCurrency(this.y)
							}
							newGaugeChartOptions.yAxis.labels.formatter = function () {
								return formatCurrency(this.value)
							}
							break;
						case "percent":
							newGaugeChartOptions.series[2].dataLabels.formatter = function () {
								return formatPercent(this.y)
							}
							newGaugeChartOptions.yAxis.labels.formatter = function () {
								return formatPercent(this.value)
							}
							break;
						default:
							newGaugeChartOptions.series[2].dataLabels.formatter = function () {
								return formatNumber(this.y)
							}
							newGaugeChartOptions.yAxis.labels.formatter = function () {
								return formatNumber(this.value)
							}
					}
				}
			} catch (e) {
				console.log("Error parsing gauge chart data", e);
				console.log(action.payload);
			}
			return { ...state, chartOptions: newGaugeChartOptions, surveyQuestionId: surveyQuestionId, dataLoaded: dataLoaded };
		default:
			console.log(`unhandled action.type: ${action.type}`)
	}
}

const ACTION = {
	NEW_PIE_CHART_DATA: "newPieChartData",
	NEW_NESTED_PIE_CHART_DATA: "newNestedPieChartData",
	NEW_STACKED_BAR_CHART_DATA: "newStackedBarChartData",
	NEW_BAR_CHART_DATA: "newBarChartData",
	NEW_COLUMN_CHART_DATA: "newColumnChartData",
	NEW_GROUPED_COLUMN_CHART_DATA: "newGroupedColumnChartData",
	NEW_CROSSTAB_CHART_DATA: "newCrosstabChartData",
	NEW_GAUGE_CHART_DATA: "newGaugeChartData",
	NEW_WAFFLE_CHART_DATA: "newWaffleChartData",
	NEW_STACKED_COLUMN_CHART_DATA: "newStackedColumnChartData",
	NEW_CHART_TABLE_DATA: "newChartTableData",
}

const HighChart = ({ chartData, chartHeight, gridHeight }) => {

	// console.log(`Highchart for surveyQuestionId: ${chartData.surveyQuestionId} re-rendering at ${(new Date()).getTime()}`);

	const [state, dispatch] = useReducer(reducer, {
		chartOptions: { ...defaultPieChartOptions },
		surveyQuestionId: null,
		dataLoaded: false
	});

	useEffect(() => {
		switch (chartData.type) {
			case "multiple choice":
				switch (chartData.chartType) {
					case "column chart":
						dispatch({
							type: ACTION.NEW_COLUMN_CHART_DATA, payload: { ...chartData, chartHeight }
						});
						break;
					case "bar chart":
						dispatch({
							type: ACTION.NEW_BAR_CHART_DATA, payload: { ...chartData, isMultipleChoice: true, chartHeight }
						});
						break;
					case "pie chart with legend":
						dispatch({
							type: ACTION.NEW_PIE_CHART_DATA, payload: { ...chartData, showLegend: true, chartHeight }
						});
						break;
					case "nested pie chart":
						dispatch({
							type: ACTION.NEW_NESTED_PIE_CHART_DATA, payload: { ...chartData, chartHeight }
						});
						break;
					case "waffle chart":
						// console.log("Waffle chart!");
						// console.log(chartData);
						dispatch({
							type: ACTION.NEW_WAFFLE_CHART_DATA, payload: { ...chartData, chartHeight }
						});
						break;
					case "age crosstab":
					case "gender crosstab":
					case "firm type crosstab":
					case "AUM crosstab":
					case "team crosstab":
					case "tenure crosstab":
					case "region crosstab":
						// console.log("crosstab: " + chartData.chartType);
						// console.log(chartData);
						dispatch({
							type: ACTION.NEW_STACKED_COLUMN_CHART_DATA, payload: { ...chartData, chartHeight }
						});
						break;
					default:
						dispatch({
							type: ACTION.NEW_PIE_CHART_DATA, payload: { ...chartData, showLegend: false, chartHeight }
						});
				}
				break;
			case "matrix":
				dispatch({
					type: ACTION.NEW_STACKED_BAR_CHART_DATA, payload: { ...chartData, chartHeight }
				});
				break;
			case "text":
				dispatch({
					type: ACTION.NEW_BAR_CHART_DATA, payload: { ...chartData, chartHeight }
				});
				break;
			case "numeric":
				switch (chartData.chartType) {
					case "age crosstab":
					case "team crosstab":
					case "firm type crosstab":
					case "gender crosstab":
					case "AUM crosstab":
					case "tenure crosstab":
					case "region crosstab":
						dispatch({
							type: ACTION.NEW_CROSSTAB_CHART_DATA, payload: { ...chartData, chartHeight }
						});
						break;
					default:
						// includes chartData.chartType === "gauge"
						dispatch({
							type: ACTION.NEW_GAUGE_CHART_DATA, payload: { ...chartData, chartHeight }
						});
				}
				break;
			case "constant sum":
				switch (chartData.chartType) {
					case "table":
						dispatch({
							type: ACTION.NEW_CHART_TABLE_DATA, payload: { ...chartData }
						});
						break;
					case "column chart":
						dispatch({
							type: ACTION.NEW_GROUPED_COLUMN_CHART_DATA, payload: { ...chartData, chartHeight }
						});
						break;
					default:
						dispatch({
							type: ACTION.NEW_PIE_CHART_DATA, payload: { ...chartData, showLegend: false, chartHeight }
						});
						break;
				}
				break;
			default:
				console.log("Unhandled chart type: " + chartData.chartType);
		}
	}, [chartData, chartHeight, gridHeight]);

	return (
		state.dataLoaded
			?
			<div className={chartData.dataWithheld === true ? "disabled" : ""}>
				{
					(chartData.chartType === "waffle chart")
						?
						<WaffleChart chartdata={state.chartOptions} disabled={chartData.dataWithheld === true} containerHeight={gridHeight} />
						:
						(chartData.chartType === "table")
							?
							<ChartTable chartdata={state.chartOptions} />
							:
							<HighchartsReact
								key={state.surveyQuestionId}
								highcharts={Highcharts}
								constructorType={'chart'}
								options={state.chartOptions}
							/>
				}
			</div>
			:
			<div className="missingDataContainer">
				<label>No data available&hellip;</label>
			</div>

	);


};

// export default HighChart;
export default React.memo(HighChart);